export const remiserias = [
    {
        label: "Seleccionar",
        value: "",
    },
    {
        label: "AL PASO REMIS",
        value: "AL PASO REMIS",
        domicilio: "PTE. PERON 1822"
    },
    {
        label: "188 REMIS",
        value: "188 REMIS",
        domicilio: "IRIGOYEN Nº 607"
    },
    {
        label: "CABIFAY SA",
        value: "CABIFAY SA",
        domicilio: "LAVALLE 111"
    },
    {
        label: "CLARITA REMIS",
        value: "CLARITA REMIS",
        domicilio: "RIVADAVIA Nº 852"
    },
    {
        label: "EL OMBU NORTE",
        value: "EL OMBU NORTE",
        domicilio: "GERONIMO COSTA Nº 68 Bº PRADO ESPAÑOL"
    },
    {
        label: "EL OMBU SAN NICOLAS",
        value: "EL OMBU SAN NICOLAS",
        domicilio: "AV. SAVIO Nº 675"
    },
    {
        label: "EL SOL",
        value: "EL SOL",
        domicilio: "AV. SAVIO N.º 1371"
    },
    {
        label: "EL VENCEDOR",
        value: "EL VENCEDOR",
        domicilio: "LA MADRID Y AV. ALBERDI"
    },
    {
        label: "GÈNESIS",
        value: "GÈNESIS",
        domicilio: "AV. MORENO Nº 510"
    },
    {
        label: "LA BUENOS AIRES",
        value: "LA BUENOS AIRES",
        domicilio: "AZOPARDO Nº 36"
    },
    {
        label: "LA CIUDAD",
        value: "LA CIUDAD",
        domicilio: "AV. ALBERDI Nº 337"
    },
    {
        label: "LA CORTADA REMIS",
        value: "LA CORTADA REMIS",
        domicilio: "FRANCIA Nº 367"
    },
    {
        label: "LA ESQUINA",
        value: "LA ESQUINA",
        domicilio: "AV. FALCON Nº 753 Y AV. MORTEO"
    },
    {
        label: "LA LEONA REMIS",
        value: "LA LEONA REMIS",
        domicilio: "27 OESTE 170"
    },
    {
        label: "LA UNION",
        value: "LA UNION",
        domicilio: "AV. LUIS VIALE Nº 289"
    },
    {
        label: "LATINA S.A.",
        value: "LATINA S.A.",
        domicilio: "FALCON Nº 500"
    },
    {
        label: "OFICINA 188 REMIS",
        value: "OFICINA 188 REMIS",
        domicilio: "ALMAFUERTE 61"
    },
    {
        label: "PLAZA GARETTO",
        value: "PLAZA GARETTO",
        domicilio: "JOSE HERNANDEZ N.º 1196"
    },
    {
        label: "PROGRESO REMIS",
        value: "PROGRESO REMIS",
        domicilio: "URQUIZA Nº 161"
    },
    {
        label: "REMIS BELGRANO",
        value: "REMIS BELGRANO",
        domicilio: "URQUIZA 103"
    },
    {
        label: "REMIS DE LA NACION",
        value: "REMIS DE LA NACION",
        domicilio: "DE LA NACION Nº 461"
    },
    {
        label: "REMIS LA TERMINAL",
        value: "REMIS LA TERMINAL",
        domicilio: "MORTEO Nº 66"
    },
    {
        label: "REMIS PARANA",
        value: "REMIS PARANA",
        domicilio: "CARLOS PELLEGRINI Nº 140"
    },
    {
        label: "REMISAN",
        value: "REMISAN",
        domicilio: "AV. ALBERDI Nº 337"
    },
    {
        label: "REMISES FALCON",
        value: "REMISES FALCON",
        domicilio: "AV.FALCON Nº 245"
    },
    {
        label: "REMISES VIP",
        value: "REMISES VIP",
        domicilio: "OLLEROS Nº 17"
    },
    {
        label: "ROYAL CAR S.R.L.",
        value: "ROYAL CAR S.R.L.",
        domicilio: "LEON GURUCIAGA Nº 721"
    },
    {
        label: "SAVIO OESTE",
        value: "SAVIO OESTE",
        domicilio: "PRESIDENTE PERON Nº 1375"
    },
    {
        label: "SAVIO REMIS",
        value: "SAVIO REMIS",
        domicilio: "AV. SAVIO Nº 612"
    },
    {
        label: "STILO CENTRO",
        value: "STILO CENTRO",
        domicilio: "MITRE Nº 190/192"
    },
    {
        label: "SU REMIS",
        value: "SU REMIS",
        domicilio: "PRESIDENTE PERON Nº 953"
    },
]


export const meses = [  
"Enero",
"Febrero",
"Marzo",
"Abril",
"Mayo",
"Junio",
"Julio",
"Agosto",
"Septiembre",	
"Octubre",	
"Noviembre",	
"Diciembre",
];


export const modelos = [
    "2021",
    "2020",
    "2019",
    "2018",
    "2017",
    "2016"
];
	
	
	
	

	
	
	
	
	
	
	
	
	
	
	
	
	
	
